import { render, staticRenderFns } from "./OrderSectionComponent.vue?vue&type=template&id=bdf4a3c0&scoped=true"
import script from "./OrderSectionComponent.js?vue&type=script&lang=js&external"
export * from "./OrderSectionComponent.js?vue&type=script&lang=js&external"
import style1 from "./OrderSectionComponent.vue?vue&type=style&index=1&id=bdf4a3c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdf4a3c0",
  null
  
)

export default component.exports